
import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-esthe-floral-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/7a798cdea47b3c726b4bebe778e44b07/a2250d0a8ea9045f99958c9c8aaa0772.png"
              alt="Aesthetic Clinic Logo"
              className="h-32 w-auto"
            />
          </div>

          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-sm tracking-wider uppercase text-esthe-cafe-noir hover:text-esthe-light-bronze transition-colors cursor-pointer"
            >
              HOME
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm tracking-wider uppercase text-esthe-cafe-noir hover:text-esthe-light-bronze transition-colors cursor-pointer"
            >
              ABOUT US
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-sm tracking-wider uppercase text-esthe-cafe-noir hover:text-esthe-light-bronze transition-colors cursor-pointer"
            >
              SERVICES
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-sm tracking-wider uppercase text-esthe-cafe-noir hover:text-esthe-light-bronze transition-colors cursor-pointer"
            >
              GALLERY
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-sm tracking-wider uppercase text-esthe-cafe-noir hover:text-esthe-light-bronze transition-colors cursor-pointer"
            >
              TESTIMONIALS
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-sm tracking-wider uppercase text-esthe-cafe-noir hover:text-esthe-light-bronze transition-colors cursor-pointer"
            >
              CONTACT
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="px-8 py-3 bg-esthe-light-bronze text-esthe-floral-white rounded-full text-sm font-medium hover:bg-esthe-mocha transition-colors whitespace-nowrap cursor-pointer"
          >
            Book Consultation
          </button>
        </div>
      </div>
    </nav>
  );
}
